import { inject, observer } from 'mobx-react';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Card, CardActions, CardContent, CardTitle, Input, LinkButton, TutorialButtonAndBackButton, withGrid } from '../../Components';
import { DepositoStore, DEPOSITO_STORE, MonografiaStore, MONOGRAFIA_STORE, SituacaoDoDeposito, JustificativaValidator } from '../../Store';
import { TccCard } from '../Shared/MonografiaCard';
import JustificativaDaReprovacaoModal from './Components/JustificativaDaReprovacaoModal';
import { GlobalErrorToast } from '../Shared/GlobalErrorToast';
import { format } from 'date-fns';
import Tutorial_Professor from "../../Utils/Tutorial/Manual_do_portal_do_TCC_Professor.pdf";
import PageSubTitle from "../../Components/PageSubTitle";

interface IProps extends RouteComponentProps<{ id: string }> {
  [MONOGRAFIA_STORE]: MonografiaStore;
  [DEPOSITO_STORE]: DepositoStore;
}

interface IState {
  modalIsOpen: boolean;
}

const CardContentWithGrid = withGrid(CardContent);

const StyledCardActions = styled(CardActions)`
  padding: 12px 24px;

  button {
    margin-left: 15px;
  }
`;

const StyledText = styled.div`
  color: red;
`;

const StyledInput = styled(Input) <any>`
  margin-top: 7px;
`;

@inject(MONOGRAFIA_STORE)
@inject(DEPOSITO_STORE)
@observer
export default class MonografiaPage extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      modalIsOpen: false
    };
  }

  componentDidMount() {
    const monografiaStore = this.props[MONOGRAFIA_STORE];
    const id = parseInt(this.props.match.params.id);
    monografiaStore.getMonografiaComDepositoDoOrientando(id);
  }

  aprovarDeposito = async () => {
    const depositoStore = this.props[DEPOSITO_STORE];

    await depositoStore.aprovarDeposito();
    if (!depositoStore.depositoValidationError) {
      var { history, match } = this.props;
      history.push(`/professor/agendamento/${match.params.id}`);
    }
  };

  openModalJustificativa = () => {
    const store = this.props[DEPOSITO_STORE];
    store.updateField('justificativa', '');
    this.setState({ modalIsOpen: true });
  }

  onResumeClick = () => {
    window.open(Tutorial_Professor);
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const store = this.props[DEPOSITO_STORE];

    store.updateField(name, value);
  }

  reprovarDeposito = async () => {
    const depositoStore = this.props[DEPOSITO_STORE];
    const { justificativa, setJustificativaError } = depositoStore;

    const errors = JustificativaValidator.getErrors({ justificativa });
    setJustificativaError(errors);

    if (!errors) {
      var { history } = this.props;
      this.setState({ modalIsOpen: false });
      await depositoStore.reprovarDeposito();
      history.push('/professor');
    }
  };

  render() {
    const {
      [MONOGRAFIA_STORE]: monografiaStore,
      [DEPOSITO_STORE]: depositoStore,
      history
    } = { ...this.props };

    const { monografia } = monografiaStore;
    const { deposito, depositoValidationError, justificativa, justificativaValidationError } = depositoStore;

    return (
      <>
        <PageSubTitle subTitle={'Detalhes da Monografia'} />
        <TutorialButtonAndBackButton
          openTutorial={this.onResumeClick}
          voltar={() => history.push('/professor')}
        />
        <GlobalErrorToast messages={depositoValidationError && depositoValidationError.global} />
        <Card>
          <CardTitle>Depósito realizado em {format(deposito.dataDoDeposito, 'DD/MM/YYYY')} {format(deposito.dataDoDeposito, 'HH:mm')}</CardTitle>
          <CardContentWithGrid tablet='10fr 2fr'>
            <StyledInput
              label='Arquivo'
              autoComplete='off'
              type='text'
              disabled={true}
              value='deposito.pdf'
            />
            {deposito.id > 0 ? (
              <LinkButton
                href={`${process.env.REACT_APP_API_URL}arquivo/${deposito.identifier}`}
                target='_blank'
              >
                Baixar
              </LinkButton>
            ) :
              <div />
            }
            <div />
            <StyledText>{depositoValidationError && depositoValidationError.file}</StyledText>
          </CardContentWithGrid>
          <StyledCardActions>
            <Button
              color='approvedColor'
              onClick={this.aprovarDeposito}
              disabled={
                deposito.situacao === SituacaoDoDeposito.aprovado
              }
            >
              Aceitar
            </Button>
            <Button
              color='errorColor'
              onClick={this.openModalJustificativa}
              disabled={deposito.situacao !== SituacaoDoDeposito.pendente}
            >
              Rejeitar
            </Button>
          </StyledCardActions>
        </Card>
        <TccCard monografia={monografia} />
        <JustificativaDaReprovacaoModal
          isOpen={this.state.modalIsOpen}
          outterClick={() => this.setState({ modalIsOpen: false })}
          texto={justificativa}
          onTextChange={this.handleChange}
          reprovar={this.reprovarDeposito}
          errors={justificativaValidationError}
        />
      </>
    );
  }
}
